module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "queue-navigation"
  }, [_c('div', {}, [_c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "is-small button is-darkmode-dark",
    attrs: {
      "to": {
        name: 'Summoner'
      },
      "exact-active-class": "is-primary is-selected"
    }
  }, [_vm._v("SOLO")])], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('router-link', {
    staticClass: "is-small button is-darkmode-dark",
    attrs: {
      "to": {
        name: 'SummonerFlex'
      },
      "exact-active-class": "is-primary is-selected"
    }
  }, [_vm._v("FLEX")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-255d4ee3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/QueueSwitcher.vue
// module id = 395
// module chunks = 1